import * as React from "react";
const NewsDeleteBlack = (props) => (
  <svg
    width={12}
    height={15}
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C4.20113 0 2.74286 1.45827 2.74286 3.25714V3.42857H0.514286C0.230254 3.42857 0 3.65882 0 3.94286C0 4.22689 0.230254 4.45714 0.514286 4.45714H11.4857C11.7697 4.45714 12 4.22689 12 3.94286C12 3.65882 11.7697 3.42857 11.4857 3.42857H9.25714V3.25714C9.25714 1.45827 7.79887 0 6 0ZM6 1.02857C7.23081 1.02857 8.22857 2.02634 8.22857 3.25714V3.42857H3.77143V3.25714C3.77143 2.02634 4.76919 1.02857 6 1.02857Z"
      fill="black"
    />
    <path
      d="M1.71198 5.26564C1.68511 4.98288 1.43411 4.77544 1.15136 4.80231C0.868596 4.82917 0.661154 5.08017 0.68802 5.36293C0.752799 6.04472 0.869709 6.88479 1.01999 7.96461L1.21305 9.35187C1.39762 10.6786 1.50229 11.4309 1.72875 12.0473C2.1502 13.1944 2.90198 14.1139 3.86884 14.5219C4.39387 14.7435 4.99441 14.7433 5.88845 14.7429H6.11155C7.00558 14.7433 7.60613 14.7435 8.13116 14.5219C9.09802 14.1139 9.8498 13.1944 10.2712 12.0473C10.4977 11.4309 10.6024 10.6785 10.787 9.35184L10.98 7.96462C11.1303 6.88479 11.2472 6.04472 11.312 5.36293C11.3388 5.08017 11.1314 4.82917 10.8486 4.80231C10.5659 4.77544 10.3149 4.98288 10.288 5.26564C10.2256 5.92253 10.1119 6.74059 9.95956 7.83505L9.77967 9.12764C9.58045 10.5591 9.48922 11.1933 9.30578 11.6926C8.95203 12.6554 8.3638 13.3074 7.73127 13.5743C7.42256 13.7046 7.04857 13.7143 6 13.7143C4.95143 13.7143 4.57744 13.7046 4.26873 13.5743C3.6362 13.3074 3.04797 12.6554 2.69422 11.6926C2.51078 11.1933 2.41955 10.5591 2.22033 9.12764L2.04044 7.83505C1.88813 6.74059 1.77439 5.92253 1.71198 5.26564Z"
      fill="black"
    />
  </svg>
);
export default NewsDeleteBlack;
